<template>
  <div class="side-container" :style="{'background-color': this.$store.getters.skin.sidebarBackgroundColor}">
    <!-- logo -->
    <Logo v-if="!$store.getters.topNav"/>
    <!-- side menu -->
    <SideMenu class="sidebar-menu"/>
    <Hamburger/>
  </div>
</template>

<script>
import Logo from '../Logo'
import SideMenu from '../SideMenu'
import Hamburger from '../Hamburger'
import {mapGetters} from "vuex";

export default {
  components: {Logo, Hamburger, SideMenu},
  computed: {
    ...mapGetters([
      'sidebar',
    ]),
  },
}
</script>
<style lang="less" scoped>
.side-container {
  height: 100%;
  //background-color: #ec0f0f;
  box-shadow: 2px 2px 4px #00000014;
  -webkit-box-shadow: 2px 2px 4px #00000014;

  display: flex;
  flex-direction: column;

  .sidebar-menu {
    flex: 1;
  }
}
</style>
